import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosBuzzOne } from '../../../axios';
import { TOKEN_NAME } from '../../constants';
import { moduleName } from '../../moduleInfo';
import { meApiRoute, signInRoute } from '../../utils/apiRoutes';

export const signInAsync = createAsyncThunk(
  `${moduleName}/signin`,
  async (payload) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: signInRoute(),
        data: payload,
        headers: { 'x-user-type': 'BCC' },
      });

      const data = response.data;
      // console.log('dataa', data);//
      return data;
    } catch (error) {
      return Promise.reject(new Error('Invalid email or password'));
    }
  }
);

export const getMeApiAsync = createAsyncThunk(
  `${moduleName}/getMeApiAsync`,
  async () => {
    const response = await axiosBuzzOne({
      method: 'GET',
      url: meApiRoute(),
      headers: { 'x-user-type': 'BCC' },
    });
    const data = response;
    return data;
  }
);

export const getLoginMeApiAsync = createAsyncThunk(
  `${moduleName}/getLoginMeApiAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'GET',
      url: meApiRoute(),
      headers: { 'x-user-type': 'BCC', Authorization: payload.token },
    });
    const data = response;
    return data;
  }
);

const signInSlice = createSlice({
  name: `${moduleName}/auth`,
  initialState: {
    loading: false,
    token: localStorage.getItem(TOKEN_NAME),
    isAuthenticated: null,
    user: null,
    me: null,
    loginMe: null,
  },
  reducers: {
    userLoading: (state) => {
      state.loading = true;
    },
    userLoaded: (state, action) => {
      state.isAuthenticated = true;
      state.loading = false;
      state.user = action.payload;
    },
    authError: (state) => {
      state.isAuthenticated = false;
      state.loading = false;
      state.user = null;
      state.token = null;
      localStorage.removeItem(TOKEN_NAME);
    },
    logOut: (state) => {
      state.isAuthenticated = false;
      state.loading = false;
      state.user = null;
      state.token = null;
      localStorage.removeItem(TOKEN_NAME);
    },
  },
  extraReducers: {
    [signInAsync.fulfilled]: (state, action) => {
      state.loading = false;
      if (action.payload) {
        state.isAuthenticated = true;
        localStorage.setItem(TOKEN_NAME, action.payload.token);
      }
    },
    [signInAsync.pending]: (state) => {
      state.loading = true;
    },
    [signInAsync.rejected]: (state) => {
      state.isAuthenticated = false;
      state.loading = false;
      state.user = null;
      state.token = null;
      localStorage.removeItem(TOKEN_NAME);
    },
    [getMeApiAsync.pending]: (state) => {
      state.loading = true;
    },
    [getMeApiAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.me = action.payload;
    },
    [getMeApiAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getLoginMeApiAsync.pending]: (state) => {
      state.loading = true;
    },
    [getLoginMeApiAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.loginMe = action.payload;
    },
    [getLoginMeApiAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const { logOut, userLoading, userLoaded } = signInSlice.actions;

export default signInSlice.reducer;
